const INIT_STATE = { timer: false }

const timer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case "START_TIMER":
      return {
        ...state,
        timer: true,
      }

    case "STOP_TIMER":
      return {
        ...state,
        timer: false,
      }

    default:
      return state
  }
}

export default timer
